import { render } from "./ShockDataGroup.vue?vue&type=template&id=215a318b&scoped=true"
import script from "./ShockDataGroup.vue?vue&type=script&lang=js"
export * from "./ShockDataGroup.vue?vue&type=script&lang=js"

import "./ShockDataGroup.vue?vue&type=style&index=0&id=215a318b&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215a318b"]])

export default __exports__